import React from 'react';
import { useCallback, useEffect } from 'react';
import { useFormikContext } from 'formik';

import debounce from 'lodash.debounce';

export function InvisibleAutoSubmitButton(props: { delayBeforeSubmitting?: number }) {
  const DEFAULT_DELAY_MILLISECONDS = 50;
  const formik = useFormikContext();

  const debouncedSubmit = useCallback(
    debounce(() => {
      formik.submitForm();
    }, props.delayBeforeSubmitting || DEFAULT_DELAY_MILLISECONDS),
    [formik.submitForm, props.delayBeforeSubmitting],
  );

  useEffect(() => debouncedSubmit, [debouncedSubmit, formik.values]);

  return <></>;
}
